export const Released = () => (
  <svg
    width="88"
    height="116"
    viewBox="0 0 88 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 46.1917L1 80.1917V90.6917L34.643 83.6917M34.643 83.6917C35.291 89.2657 35.962 94.1687 36.5 97.6917L28 106.192V111.692L39.5 109.192L44 114.192L48.5 109.192L60 111.692V106.192L51.5 97.6917C52.038 94.1687 52.709 89.2657 53.357 83.6917M34.643 83.6917C33.083 70.2837 31.652 52.9937 32.5 41.6917C33.7 25.6917 40.667 8.69165 44 2.19165C47.333 8.69165 54.3 25.6917 55.5 41.6917C56.348 52.9937 54.917 70.2837 53.357 83.6917M53.357 83.6917L87 90.6917V80.1917L56 46.1917M48 27.1917C48 28.2967 46.209 29.1917 44 29.1917C41.791 29.1917 40 28.2967 40 27.1917C40 26.0867 41.791 25.1917 44 25.1917C46.209 25.1917 48 26.0867 48 27.1917Z"
      stroke="#FFF2AE"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);
